import React, { useState, useEffect } from "react";
import { FaClipboard } from "react-icons/fa";
import "./UrlPopup.css"; // Create this CSS file next

const UrlPopup = ({ url, onClose, isLoading }) => {
  const [copySuccess, setCopySuccess] = useState("");

  const handleCopy = () => {
    navigator.clipboard.writeText(url);
    setCopySuccess("Copied!");
    setTimeout(() => {
      setCopySuccess("");
    }, 2000);
  };

  return (
    <div className="url-popup-overlay">
      <div className="url-popup-content">
        <button className="close-button" onClick={onClose}>
          X
        </button>
        <h2>Important Link</h2>
        <div className="scroll-content mt-2">
          {" "}
          <p className="url-instructions">
            If you are opening the store via the <strong>FAU-G</strong> game,
            you need to follow the below steps.
          </p>
          <div className="url-steps">
            {/* <h3>Steps:</h3> */}
            <ol>
              <li>
                Step 1: Copy the link below and open any browser on your phone
                (Chrome, Safari, Brave, etc.).
              </li>
              <li>
                Step 2: Paste the link in the URL bar and proceed with the KYC
                flow.
              </li>
            </ol>
          </div>
          <div className="url-display-box">
            {isLoading ? (
              <div className="url-loader"></div> // Simple spinner
            ) : (
              <span className="url-text">{url}</span>
            )}
            <div className="d-flex align-items-center justify-content-center mt-3">
              <button
                onClick={handleCopy}
                className="copy-button"
                disabled={isLoading}
              >
                <FaClipboard /> {copySuccess || "Copy"}
              </button>
            </div>
          </div>
          {copySuccess && <p className="copy-success-message">{copySuccess}</p>}
          <div className="url-notes">
            <p className="note highlight-note">
              <strong>Note 1:</strong> If you are already in a browser, you can
              ignore this message.
            </p>
            <p className="note highlight-note">
              <strong>Note 2:</strong> This link is unique to each user and
              allows submission of only one form. If you share your link with
              someone else and they submit the form, you will lose your reward.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UrlPopup;
